<template>
  <div>
    <div v-if="isColorsPending" class="loader">
      <b-spinner label="Loading..." variant="primary"/>
    </div>
    <ul v-if="!isColorsPending" class="colorpicker">
      <li
        v-for="color in colors"
        :key="color.title"
        class="color-item"
        :style="{ background: color.hex }"
        v-on:click="onSelectColor(color)"
        v-b-tooltip.bottom.hover.noninteractive
        :title="color.title"
      />
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ColorPicker',
  data () {
    return {
    };
  },
  props: {
    colors: Array,
  },

  computed: {
    isColorsPending () {
      return this.$store.getters['elements/isColorsPending'];
    },
  },
  methods: {
    onSelectColor (color) {
      this.$emit('onSelectColor', color);
    },
  }
};
</script>

<style scoped>
  .colorpicker {
    display: flex;
    flex-wrap: wrap;
    margin: auto;
    padding: 0;
    width: 160px;
  }

  .color-item {
    border: 1px solid #000;
    cursor: pointer;
    height: 30px;
    list-style: none;
    margin: 5px;
    width: 30px;
  }
</style>
